import { render, staticRenderFns } from "./contact-details-p1.vue?vue&type=template&id=256ccc08&scoped=true"
import script from "./contact-details-p1.vue?vue&type=script&lang=js"
export * from "./contact-details-p1.vue?vue&type=script&lang=js"
import style0 from "./contact-details-p1.vue?vue&type=style&index=0&id=256ccc08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256ccc08",
  null
  
)

export default component.exports